import { ApiActionTypes, buildApiTypeAction } from "src/common/apiLoader/apiLoaderUtils";

export const CLEAN_CHAT = 'CLEAN_CHAT';

const SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE';
export const SEND_CHAT_MESSAGE_API = buildApiTypeAction(SEND_CHAT_MESSAGE, ApiActionTypes.REQUEST)
export const SEND_CHAT_MESSAGE_API_SUCCESS = buildApiTypeAction(SEND_CHAT_MESSAGE, ApiActionTypes.SUCCESS)
export const SEND_CHAT_MESSAGE_API_ERROR = buildApiTypeAction(SEND_CHAT_MESSAGE, ApiActionTypes.ERROR)
